/**
 * The limits on the platform admin's shared rules, per group (all businesses, or one industry). A copy of SHARED_RULE_LIMITS in
 * packages/shared/rules/rules.ts (the web app does not import the shared package); lib/test/ruleLimits.test.ts keeps them identical.
 */
export const SHARED_RULE_LIMITS = { maxRules: 60, maxTotalChars: 14000 } as const;
/** One rule's length, enforced by the database for every rule. */
export const MAX_RULE_CHARS = 400;
/** Who reads a shared rule. */
export const RULE_READERS = [
  { value: "both", label: "Both models" },
  { value: "backend", label: "Backend (decides and uses the tools)" },
  { value: "voice", label: "Voice (what it says and how)" },
] as const;
export type RuleReaderValue = (typeof RULE_READERS)[number]["value"];
